import {
  GridActionsCellItem,
  GridActionsCellItemProps,
} from '@mui/x-data-grid-premium';
import { RefAttributes } from 'react';
import AuthorizationGate from 'components/authorization-gate/authorization-gate.component';

type PermissionedGridActionCellItemType = {
  permission?: string;
} & GridActionsCellItemProps &
  RefAttributes<HTMLButtonElement>;

const PermissionedGridActionCellItem = ({
  permission,
  ...rest
}: PermissionedGridActionCellItemType) => {
  return (
    <AuthorizationGate permission={permission}>
      <GridActionsCellItem {...rest} />
    </AuthorizationGate>
  );
};

export default PermissionedGridActionCellItem;
